import React from 'react'
import ActionButton from './UI/ActionButton'
import { clickableProps } from '../utils/clickableProps'

const EventsTable = ({
  events,
  loading,
  error,
  onViewEvent,
  onNewEvent,
  onRefresh,
  formatDateRange,
  getEventStatus
}) => {
  const upcomingEvents = events.filter(e => getEventStatus(e.startDate) === 'upcoming');

  if (loading) {
    return (
      <div className="text-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 mx-auto mb-4" style={{borderColor: 'var(--theme-primary)'}}></div>
        <p style={{color: 'var(--theme-text-secondary)'}}>Loading events...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="px-4 py-3 rounded-xl text-sm mb-4" style={{
        backgroundColor: 'rgba(239, 68, 68, 0.2)',
        borderColor: 'rgba(239, 68, 68, 0.5)',
        border: '1px solid',
        color: 'var(--theme-text-primary)'
      }}>
        {error}
      </div>
    );
  }

  if (upcomingEvents.length === 0) {
    return (
      <div className="text-center py-12">
        <h3 className="text-xl font-semibold mb-2" style={{color: 'var(--theme-text-secondary)'}}>No upcoming events</h3>
        <p className="mb-4" style={{color: 'var(--theme-text-muted)'}}>Create your first event to get started!</p>
        <ActionButton
          onClick={onNewEvent}
          text="Create Event"
          gradientColors={['var(--theme-primary)', 'var(--theme-secondary)']}
          icon={
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
          }
        />
      </div>
    );
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <span className="text-sm text-gray-400">
          {events.length} total events, {upcomingEvents.length} upcoming
        </span>
        <button
          onClick={onRefresh}
          className="text-sm px-3 py-1 bg-white/10 hover:bg-white/20 rounded-lg transition-colors"
          style={{color: 'var(--theme-text-secondary)'}}
        >
          🔄 Refresh
        </button>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
        <thead>
          <tr className="border-b border-white/20">
            <th className="text-left font-semibold py-3 px-4" style={{color: 'var(--theme-text-primary)'}}>Event Name</th>
            <th className="text-left font-semibold py-3 px-4" style={{color: 'var(--theme-text-primary)'}}>Event Date</th>
            <th className="text-left font-semibold py-3 px-4" style={{color: 'var(--theme-text-primary)'}}>Event Location</th>
          </tr>
        </thead>
        <tbody>
          {upcomingEvents.map((event) => (
            <tr
              key={event._id}
              className="border-b border-white/10 hover:bg-white/10 transition-all duration-300 cursor-pointer group focus:outline-none focus-visible:ring-2 focus-visible:ring-purple-400"
              {...clickableProps(() => onViewEvent(event._id), `View event ${event.name}`)}
              title="Click to view event details"
            >
              <td className="py-4 px-4">
                <div>
                  <p className="font-medium group-hover:text-white transition-colors" style={{color: 'var(--theme-text-primary)'}}>{event.name}</p>
                  <p className="text-sm group-hover:text-gray-200 transition-colors" style={{color: 'var(--theme-text-muted)'}}>{event.description || 'No description'}</p>
                </div>
              </td>
              <td className="py-4 px-4">
                <p className="group-hover:text-white transition-colors" style={{color: 'var(--theme-text-secondary)'}}>
                  {formatDateRange(event.startDate, event.endDate)}
                </p>
              </td>
              <td className="py-4 px-4">
                <p className="group-hover:text-white transition-colors" style={{color: 'var(--theme-text-secondary)'}}>{event.venueName}</p>
                <p className="text-sm group-hover:text-gray-200 transition-colors" style={{color: 'var(--theme-text-muted)'}}>{event.country}</p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </div>
  );
};

export default EventsTable